import { Users, FileText, TrendingUp, Activity } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

interface StatsCardsProps {
  stats: {
    users: {
      total: number;
      recent: number;
      active: number;
      byPermission: Array<{ permission: string; count: number }>;
    };
    prompts: {
      stats: any[];
      favorites: any[];
    };
  };
}

export function StatsCards({ stats }: StatsCardsProps) {
  if (!stats) {
    return null;
  }

  const totalPrompts = stats.prompts?.stats?.length || 0;
  const totalFavorites = stats.prompts?.favorites?.reduce((sum, p) => sum + (p.count || 0), 0) || 0;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {/* 总用户数 */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">总用户数</CardTitle>
          <Users className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.users?.total || 0}</div>
          <p className="text-xs text-muted-foreground">
            最近 7 天新增 {stats.users?.recent || 0} 人
          </p>
        </CardContent>
      </Card>

      {/* 活跃用户 */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">活跃用户</CardTitle>
          <Activity className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.users?.active || 0}</div>
          <p className="text-xs text-muted-foreground">
            最近 7 天活跃用户数
          </p>
        </CardContent>
      </Card>

      {/* Prompt 总数 */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Prompt 总数</CardTitle>
          <FileText className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalPrompts}</div>
          <p className="text-xs text-muted-foreground">
            总收藏数 {totalFavorites}
          </p>
        </CardContent>
      </Card>

      {/* 用户增长 */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">用户增长</CardTitle>
          <TrendingUp className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {(stats.users?.recent || 0) > 0 ? '+' : ''}{stats.users?.recent || 0}
          </div>
          <p className="text-xs text-muted-foreground">
            最近 7 天新增用户
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

